import styled from 'styled-components';

export const ChartTooltip = styled.div(({ theme }) =>
  theme.withMedia({
    background: theme.styleguideColors.backgroundPrimary,
    boxShadow: theme.boxShadow.tooltip,
    borderRadius: theme.borderRadius.base,
    padding: '8px 16px',
  })
);
